<div
  class="sidebar w-full h-full flex flex-col"
  [ngClass]="{ 'slide-in': sidebarState === 'in', 'slide-out': sidebarState === 'out' }">
  <div class="py-[20px] px-8 border-b border-neutral-100 flex flex-row items-center justify-between">
    <xos-company-logo [height]="47"></xos-company-logo>
    <xos-button class="block lg:hidden"
      [appearance]="'icon'"
      (click)="closeSidebar()"
      icon="x"
      size="sm">
    </xos-button>
  </div>
  <div class="flex-grow flex flex-col overflow-y-auto menu-items gap-[30px] p-8">
    @for (menuItem of menuItems; track menuItem) {
      @if (!menuItem.isExternal) {
        <a
          class="menu-item text-2xl"
          [ngClass]="{'active': menuItem.route === currentRoute}"
          [routerLink]="menuItem.route">
          {{ menuItem.name }}
        </a>
      }
      @if (menuItem.isExternal) {
        <a
          class="menu-item text-2xl"
          [ngClass]="{'active': menuItem.route === currentRoute}"
          [href]="menuItem.route">
          {{ menuItem.name }}
        </a>
      }
    }

    <xos-button [appearance]="'secondary'" (click)="goToStore()" size="sm">Login</xos-button>
  </div>
</div>